export default "__VITE_ASSET__ufVAtMgA__"